import { c as _c } from "react/compiler-runtime";
import React from "react";
import WaveWinnersDropHeaderTotalVotes from "./WaveWinnersDropHeaderTotalVotes";
import WaveWinnersDropHeaderVoters from "./WaveWinnersDropHeaderVoters";
import WaveWinnersDropHeaderAuthorHandle from "./WaveWinnersDropHeaderAuthorHandle";
import type { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import WinnerDropBadge from "@/components/waves/drops/winner/WinnerDropBadge";
import WaveDropTime from "@/components/waves/drops/time/WaveDropTime";
import { DropAuthorBadges } from "@/components/waves/drops/DropAuthorBadges";
interface WaveWinnersDropHeaderProps {
  readonly winner: ApiWaveDecisionWinner;
  readonly showVotingInfo?: boolean | undefined;
}
export const WaveWinnersDropHeader: React.FC<WaveWinnersDropHeaderProps> = t0 => {
  const $ = _c(24);
  const {
    winner,
    showVotingInfo: t1
  } = t0;
  const showVotingInfo = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== winner) {
    t2 = <WaveWinnersDropHeaderAuthorHandle winner={winner} />;
    $[0] = winner;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `winner-author-badges-${winner.drop.id}`;
  let t4;
  if ($[2] !== t3 || $[3] !== winner.drop.author) {
    t4 = <DropAuthorBadges profile={winner.drop.author} tooltipIdPrefix={t3} />;
    $[2] = t3;
    $[3] = winner.drop.author;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="tw-size-[3px] tw-flex-shrink-0 tw-rounded-full tw-bg-iron-600" />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== winner.drop.created_at) {
    t6 = <WaveDropTime timestamp={winner.drop.created_at} />;
    $[6] = winner.drop.created_at;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t2 || $[9] !== t4 || $[10] !== t6) {
    t7 = <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-1.5 tw-gap-y-1">{t2}{t4}{t5}{t6}</div>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = winner.drop.winning_context?.decision_time ?? null;
  let t9;
  if ($[12] !== t8 || $[13] !== winner.place) {
    t9 = <WinnerDropBadge rank={winner.place} decisionTime={t8} />;
    $[12] = t8;
    $[13] = winner.place;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t7 || $[16] !== t9) {
    t10 = <div className="tw-flex tw-w-full tw-flex-col tw-items-start tw-gap-y-2.5 xl:tw-w-auto">{t7}{t9}</div>;
    $[15] = t7;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== showVotingInfo || $[19] !== winner) {
    t11 = showVotingInfo && <div className="tw-mt-1 tw-whitespace-nowrap sm:tw-mt-0"><div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-2 tw-gap-y-2 sm:tw-gap-x-4 xl:tw-flex-nowrap"><WaveWinnersDropHeaderTotalVotes winner={winner} /><WaveWinnersDropHeaderVoters winner={winner} /></div></div>;
    $[18] = showVotingInfo;
    $[19] = winner;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10 || $[22] !== t11) {
    t12 = <div onClick={_temp} className="tw-flex tw-w-full tw-flex-wrap tw-justify-between tw-gap-y-2 xl:tw-flex-nowrap">{t10}{t11}</div>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
};
function _temp(e) {
  return e.stopPropagation();
}